import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "./BaseIcon";
// This SVG code is derived from Heroicons (https://heroicons.com)
// check
export default function IconCheck(props) {
    return (_jsx(BaseIcon, Object.assign({ viewBox: "0 0 24 24" }, props, { children: _jsx("path", { fill: "currentColor", d: "M20.1934 4.20994C20.7678 4.59288 20.923 5.36896 20.5401 5.94337L11.5401 19.4434C11.3323 19.755 10.9958 19.957 10.6232 19.9939C10.2505 20.0308 9.88092 19.8987 9.61612 19.6339L3.61612 13.6339C3.12796 13.1457 3.12796 12.3543 3.61612 11.8661C4.10427 11.378 4.89573 11.378 5.38388 11.8661L10.3057 16.788L18.4599 4.55662C18.8429 3.98221 19.619 3.827 20.1934 4.20994Z" }) })));
}
